import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UnassignUserEntitlementsResultModal} from './unassign-user-entitlements.result.modal';
import {
    clearResult,
    selectUnassignUserEntitlementsBulkUuid,
    selectUnassignUserEntitlementsShown,
    selectUnassignUserEntitlementsTask,
} from './unassign-user-entitlements.slice';


export const UnassignUserEntitlementsResult = () => (
    <BulkActionResult
        actionIdSelector={selectUnassignUserEntitlementsBulkUuid}
        actionTaskSelector={selectUnassignUserEntitlementsTask}
        actionShownSelector={selectUnassignUserEntitlementsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <UnassignUserEntitlementsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
